<template>
  <section v-if="propOs"
           class="container">
    <div class="row pl-4">
      <span class="col-5 table-infos-title">Serviços</span>
      <span class="col-1 table-infos-title">Qtd</span>
      <span class="col-2 table-infos-title">Valor Unitário</span>
      <span class="col-2 table-infos-title">Valor Total</span>
    </div>
    <div>
      <div v-for="item in propOs.itens"
           :key="item.custa_id + Math.random()"
           class="row pl-4">
        <span class="col-5 pl-4">
          {{ item.custa.ato.length > 30 ?
            item.custa.ato.substring(0, 30) + '...' : item.custa.ato }}
        </span>
        <span class="col-1">{{ item.quantidade }}</span>
        <input id="custa_valor"
               v-money="money"
               :value="item.quantidade > 1 ? item.valor / item.quantidade : item.valor"
               disabled
               class="col-2"
               size="sm"
               trim>
        <input id="custa_valor_total_custa"
               v-money="money"
               :value="item.valor"
               disabled
               class="col-2"
               name="custa_ipesp"
               size="sm"
               trim>
      </div>   
    </div>
  </section>
</template>

<script>

  // Imports
  import { VMoney } from 'v-money'

  export default ({
    name: 'ItemTableOs',
    directives: {
      money: VMoney
    },
    props: {
      propOs: {type: Object, default: null},
      propValorTotal: {type: Number, default: 0}
    },
    data () {
      return {
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
      }
    },
    methods: {

    }
  })
</script>